import styled from 'styled-components';
import tw, { classnames, width, display, justifyContent, backgroundColor, position, zIndex, padding, borderColor, boxShadow, borderRadius, space, alignItems, inset, textColor, transitionProperty, cursor, height } from 'tailwindcss-classnames';

export const Content = styled.div.attrs({
    className: classnames(width('w-full'), display('flex'), justifyContent('justify-between'), backgroundColor('bg-white'), position('relative', 'sticky'), zIndex('z-20'), padding('px-4', 'py-3'), borderColor('border-gray-200'), boxShadow('shadow-sm'), borderRadius('rounded-sm'))
})``;

export const TitleContent = styled.div.attrs({
    className: classnames(display('flex'), space('space-x-2'), alignItems('items-center'))
})``;

export const SearchInputContent = styled.div.attrs({
    className: classnames(display('flex'), space('space-x-2'), alignItems('items-center'))
})``;

export const OptionsContent = styled.div.attrs({
    className: classnames(inset('right-0'), display('flex'), space('space-x-1', 'space-x-2'))
})``;

export const OptionsAnchor = styled.a.attrs({
    className: classnames(textColor('hover:text-purple-400'), backgroundColor('hover:bg-purple-200'), borderRadius('rounded-full'), transitionProperty('transition-all'), cursor('cursor-pointer'), height('h-auto'), padding('px-2', 'py-1'))
})`
transition-duration: 0.5s;
`;